let commerceAlarmType = [
  // 工商业报警器状态
  {
    value: 0,
    name: "正常",
    color: "#009900" // 绿色
  },
  {
    value: 1,
    name: "离线",
    color: "#999999" // 灰色
  },
  {
    value: 5,
    name: "报警",
    color: "rgba(255,103,103,1)" // 红色
  },
  {
    value: 10,
    name: "故障",
    color: "rgba(236, 141, 0, 1)" //橙色
  },
  {
    value: 19,
    name: "备电故障",
    color: "#ECEC00" // 黄色
  },
  {
    value: 20,
    name: "主电故障",
    color: "#ECEC00" // 黄色
  },
  {
    value: 21,
    name: "主电欠压",
    color: "#ECEC00" // 黄色
  }
];

let householdAlarmType = [
  {
    value: 0,
    name: "正常",
    color: "#009900" // 绿色
  },
  {
    value: 1,
    name: "离线",
    color: "#999999" // 灰色
  },
  {
    value: 5,
    name: "报警",
    color: "#FF0000" // 红色
  },
  {
    value: 10,
    name: "故障",
    color: "#ECEC00" // 黄色
  },
  {
    value: 11,
    name: "断网",
    color: "#999999" // 灰色
  }
];

let alarmProbeType = [
  {
    value: 0,
    name: "-",
    color: "#999999" // 灰色
  },
  {
    value: 1,
    name: "正常",
    color: "#009900" // 绿色
  },
  {
    value: 2,
    name: "断网",
    color: "#999999" // 灰色
  },
  {
    value: 3,
    name: "故障",
    color: "#ECEC00" // 黄色
  },
  {
    value: 4,
    name: "报警",
    color: "#FF0000" // 红色
  }
];

// 探测器状态
let detectorType = [
  {
    value: 0,
    name: "正常",
    color: "#009900" // 绿色
  },
  {
    value: 1,
    name: "首警高",
    color: "#FF0000" // 红色
  },
  {
    value: 2,
    name: "首警低",
    color: "#FF0000" // 红色
  },
  {
    value: 3,
    name: "低限报警",
    color: "#FF0000" // 红色
  },
  {
    value: 4,
    name: "高限报警",
    color: "#FF0000" // 红色
  },
  {
    value: 15,
    name: "故障",
    color: "#ECEC00" // 黄色
  },
  {
    value: 129,
    name: "断网",
    color: "#999999" // 灰色
  }
];

// 综合状态
let cmpType = [
  {
    name: "正常",
    color: "#009900" // 绿色
  },
  {
    name: "离线",
    color: "#999999" // 灰色
  },
  {
    name: "故障",
    color: "rgb(236 196 0)" // 暗黄
  },
  {
    name: "报警",
    color: "#FF0000" // 红色
  },
  {
    name: "到期",
    color: "rgb(226 221 0)" // 带点绿的黄
  }
];

let commerceRestaurantEvent = [
  {
    value: 0,
    name: "上线",
    color: "rgb(200 200 200)" //浅灰色
  },
  {
    value: 3,
    name: "高限报警",
    color: "rgba(255, 66, 66, 1)" // 红
  },
  {
    value: 4,
    name: "低限报警",
    color: "rgba(255, 66, 66, 1)" // 红
  },
  {
    value: 7,
    name: "电磁阀打开",
    color: "rgb(200 200 200)" //浅灰色
  },
  {
    value: 8,
    name: "电磁阀关闭",
    color: "rgba(6, 193, 255, 1)" //蓝色
  },
  {
    value: 11,
    name: "断网",
    color: "rgba(236, 141, 0, 1)" //橙色
  },
  {
    value: 32,
    name: "断网恢复",
    color: "rgb(200 200 200)" //浅灰色
  },
  {
    value: 131,
    name: "低限报警恢复",
    color: "rgb(200 200 200)" //浅灰色
  },
  {
    value: 132,
    name: "高限报警恢复",
    color: "rgb(200 200 200)" //浅灰色
  },
  {
    value: 301,
    name: "短路",
    color: "rgba(236, 141, 0, 1)" //橙色
  },
  {
    value: 302,
    name: "断路",
    color: "rgba(236, 141, 0, 1)" //橙色
  },
  {
    value: 303,
    name: "开始监视",
    color: "rgb(200 200 200)"
  },
  {
    value: 304,
    name: "开始自检",
    color: "rgb(200 200 200)" //浅灰色
  },
  {
    value: 351,
    name: "短路恢复",
    color: "rgb(200 200 200)" //浅灰色
  },
  {
    value: 352,
    name: "断路恢复",
    color: "rgb(200 200 200)" //浅灰色
  },
  {
    value: 999,
    name: "离线",
    color: "rgba(188, 188, 188, 1)"
  }
];
let commerceEvent = [
  {
    value: 0,
    name: "上线",
    color: "#009900" // 绿色
  },
  {
    value: 1,
    name: "首高",
    color: "rgba(255, 66, 66, 1)" // 红
  },
  {
    value: 2,
    name: "首低",
    color: "rgba(255, 66, 66, 1)" // 红
  },
  {
    value: 3,
    name: "高限报警",
    color: "rgba(255, 66, 66, 1)" // 红
  },
  {
    value: 4,
    name: "低限报警",
    color: "rgba(255, 66, 66, 1)" // 红
  },
  {
    value: 6,
    name: "模块联动",
    color: "rgba(188, 188, 188, 1)" // 灰
  },
  {
    value: 15,
    name: "探头传感器故障",
    color: "rgba(200, 200, 0, 1)" // 黄
  },
  {
    value: 19,
    name: "备电故障",
    color: "rgba(200, 200, 0, 1)"
  },
  {
    value: 20,
    name: "主电故障",
    color: "rgba(200, 200, 0, 1)"
  },
  {
    value: 21,
    name: "主电欠压",
    color: "rgba(200, 200, 0, 1)"
  },
  {
    value: 25,
    name: "控制器复位",
    color: "rgba(6, 193, 255, 1)"
  },
  {
    value: 26,
    name: "控制器开机",
    color: "rgba(6, 193, 255, 1)"
  },
  {
    value: 28,
    name: "探头传感器故障恢复",
    color: "rgba(66, 255, 66, 1)"
  },
  {
    value: 34,
    name: "主电故障恢复",
    color: "rgba(66, 255, 66, 1)"
  },
  {
    value: 35,
    name: "备电故障恢复",
    color: "rgba(66, 255, 66, 1)"
  },
  {
    value: 36,
    name: "主电欠压恢复",
    color: "rgba(66, 255, 66, 1)"
  },
  {
    value: 129,
    name: "探头传感器断网故障",
    color: "rgba(200, 200, 0, 1)"
  },
  {
    value: 130,
    name: "探头传感器断网故障恢复",
    color: "rgba(66, 255, 66, 1)"
  },
  {
    value: 131,
    name: "低限报警恢复",
    color: "rgba(66, 255, 66, 1)"
  },
  {
    value: 132,
    name: "高限报警恢复",
    color: "rgba(66, 255, 66, 1)"//绿色1
  },
  {
    value: 255,
    name: "更新探测器编号",
    color: "rgba(6, 193, 255, 1)"
  },
  {
    value: 999,
    name: "离线",
    color: "rgba(188, 188, 188, 1)"
  }
];

let householdEvent = [
  {
    value: 0,
    name: "上线",
    color: "rgb(200 200 200)" //浅灰色
  },
  {
    value: 5,
    name: "报警",
    color: "rgba(255,103,103,1)" // 红色
  },
  {
    value: 7,
    name: "电磁阀打开",
    color: "rgb(200 200 200)" //浅灰色
  },
  {
    value: 8,
    name: "电磁阀关闭",
    color: "rgba(6, 193, 255, 1)" //蓝色
  },
  {
    value: 9,
    name: "到期",
    color: "rgba(221, 216, 4, 1)" //浅黄色
  },
  {
    value: 10,
    name: "故障",
    color: "rgba(236, 141, 0, 1)" //橙色
  },
  {
    value: 11,
    name: "断网",
    color: "rgba(236, 141, 0, 1)" //橙色
  },
  /*   {
    value: 18,
    name: "电磁阀未连接",
    color: "rgba(6, 193, 255, 1)" //蓝色
  }, */
  {
    value: 30,
    name: "报警恢复",
    color: "rgb(200 200 200)" //浅灰色
  },
  {
    value: 31,
    name: "故障恢复",
    color: "rgb(200 200 200)" //浅灰色
  },
  {
    value: 32,
    name: "断网恢复",
    color: "rgb(200 200 200)" //浅灰色
  },
  {
    value: 33,
    name: "传感器寿命恢复",
    color: "rgb(200 200 200)" //浅灰色
  },
  {
    value: 999,
    name: "离线",
    color: "rgba(173,173,173,1)" // 深灰色
  }
];
// 设备告警类型
const dvcEvent = [
  {
    value: 0, name: "上线", label: "上线",
    color: "rgb(200 200 200)" //浅灰色
  },
  {
    value: 999, name: "离线", label: "离线",
    color: "rgba(173,173,173,1)" // 深灰色
  },
  {
    value: 1, name: "故障", label: "故障",
    color: "rgba(236, 141, 0, 1)" //橙色
  },
  {
    value: 2, name: "故障恢复", label: "故障恢复",
    color: "rgb(200 200 200)" //浅灰色
  },
  {
    value: 11, name: "自动启动", label: "自动启动",
    color: "rgba(6, 193, 255, 1)" //蓝色
  },
  {
    value: 12, name: "手动启动", label: "手动启动",
    color: "#ECEC00" // 黄色
  },
  {
    value: 13, name: "手动恢复", label: "手动恢复",
    color: "rgb(200 200 200)" //浅灰色
  },
]

// 家用/工商业独立式报警状态
const HCRAlarmState = {
  0: { name: "正常", color: "#009900" },
  1: { name: "报警/低限报警", color: "#FF0000" },
  2: { name: "高限报警", color: "#FF0000" }
};

// 家用/工商业独立式故障状态
const HCRBreakDownState = {
  0: { name: "正常", color: "#009900" },
  1: { name: "故障", color: "rgb(236 196 0)" },
  2: { name: "短路", color: "rgb(236 196 0)" },
  3: { name: "断路", color: "rgb(236 196 0)" },
  255: { name: "断网", color: "rgb(236 196 0)" }
};

// 采集器状态
const CollectorState = {
  0: { name: "未连接", color: "#999999" },
  1: { name: "连接", color: "#009900" }
};

const clearReasonList = [
  { label: "已确认", value: "1" },
  { label: "测试", value: "2" },
  { label: "点检", value: "3" }
];

// 电磁阀状态
const electromagnetic = {
  0: { name: "未连接", color: "#999999" },
  1: { name: "开放", color: "#009900" },
  2: { name: "闭合", color: "#000000" }
};

// 传感器寿命
const SensorLifeState = {
  0: { name: "未到期", color: "" },
  1: { name: "到期", color: "#e2dd05" }
};

// 自检状态
const SelfCheckState = {
  0: { name: "监视状态", color: "#000000" },
  1: { name: "自检状态", color: "#000000" }
};

const householdAlarmEvent = [
  // 家用探测器告警配置中的告警事件
  {
    value: 5,
    name: "报警",
    label: "报警",
    color: "rgba(255,103,103,1)" // 红色
  },
  {
    value: 9,
    name: "到期",
    label: "到期",
    color: "rgba(221, 216, 4, 1)" //浅黄色
  },
  {
    value: 10,
    name: "故障",
    label: "故障",
    color: "rgba(236, 141, 0, 1)" //橙色
  }
];
const commerceAlarmEvent = [
  // 工商系统式探测器告警配置中的告警事件
  {
    value: 1,
    name: "首高",
    label: "首高",
    color: "rgba(255, 66, 66, 1)" // 红
  },
  {
    value: 2,
    name: "首低",
    label: "首低",
    color: "rgba(255, 66, 66, 1)" // 红
  },
  {
    value: 3,
    name: "高限报警",
    label: "高限报警",
    color: "rgba(255, 66, 66, 1)" // 红
  },
  {
    value: 4,
    name: "低限报警",
    label: "低限报警",
    color: "rgba(255, 66, 66, 1)" // 红
  },
  {
    value: 15,
    name: "探头故障",
    label: "探头故障",
    color: "rgba(200, 200, 0, 1)" // 黄
  },
  {
    value: 129,
    name: "探头断网",
    label: "探头断网",
    color: "rgba(200, 200, 0, 1)"
  },
  {
    value: 20,
    name: "主电故障",
    label: "主电故障",
    color: "rgba(200, 200, 0, 1)"
  },
  {
    value: 19,
    name: "备电故障",
    label: "备电故障",
    color: "rgba(200, 200, 0, 1)"
  },
  {
    value: 21,
    name: "主电欠压",
    label: "主电欠压",
    color: "rgba(200, 200, 0, 1)"
  }
];
const commerceRestaurantAlarmEvent = [
  // 工商独立式探测器告警配置中的告警事件
  {
    value: 3,
    name: "高限报警",
    label: "高限报警",
    color: "rgba(255, 66, 66, 1)" // 红
  },
  {
    value: 4,
    name: "低限报警",
    label: "低限报警",
    color: "rgba(255, 66, 66, 1)" // 红
  },
  {
    value: 301,
    name: "短路",
    label: "短路",
    color: "rgba(236, 141, 0, 1)" //橙色
  },
  {
    value: 302,
    name: "断路",
    label: "断路",
    color: "rgba(236, 141, 0, 1)" //橙色
  }
];
const deviceType = [
  { id: 1, name: "控制设备", label: "控制设备" },
  { id: 2, name: "联动设备", label: "联动设备" },
]
const connectState = [
  { value: 0, label: "未连接" },
  { value: 1, label: "连接" },
]

const handleEventText = (events, text, valveNumber) => {
  let index = events.findIndex(item => {
    return item.value == text;
  });
  if (valveNumber) {
    if (text == 7) {
      return `电磁阀${valveNumber}打开`;
    }
    if (text == 8) {
      return `电磁阀${valveNumber}关闭`;
    }
  }
  return index > -1 ? events[index].name : "--";
};

const type = {
  LOOP_INTERVAL: 15000,
  commerceAlarmType,
  householdAlarmType,
  alarmProbeType,
  detectorType,
  commerceEvent,
  commerceRestaurantEvent,
  householdEvent,
  cmpType,
  clearReasonList,
  electromagnetic,
  HCRAlarmState,
  HCRBreakDownState,
  CollectorState,
  SensorLifeState,
  SelfCheckState,
  handleEventText,
  commerceAlarmEvent,
  commerceRestaurantAlarmEvent,
  householdAlarmEvent,
  deviceType,
  dvcEvent,
  connectState
};

export default type;



// WEBPACK FOOTER //
// ./src/views/business/monitor/monitorType.js